import { inView } from 'motion';

const ProductCta = () => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('productCta', () => ({
      init() {
        const productOptions = document.querySelector('#cartBtn');

        inView(
          productOptions,
          ({ target }) => {
            this.$root.classList.add('translate-y-full');

            return () => {
              this.$root.classList.remove('translate-y-full');
            };
          },
          {
            amount: 0.2,
          }
        );
      },
    }));
  });
};

export default ProductCta;
